import { useEffect } from 'react';

import { useLocation } from 'react-router-dom';

import { trackMetaPageView } from '../../helpers/metaPixel';

// A SINGLE-PAGE APP NEVER RELOADS, SO THE META PIXEL GETS A PAGEVIEW ON EVERY
// ROUTE CHANGE, INCLUDING THE FIRST PAGE
const useMetaPageViewTracking = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    trackMetaPageView();
  }, [pathname]);
};

export default useMetaPageViewTracking;
